module.exports = __webpack_public_path__ + "static/media/asset-planet-background.f06d630c.png";